import { Grid } from "@mui/material";
import { debounce } from "lodash";
import { useRef } from "react";
import React, { useCallback, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from "../../../../framework/Checkbox";
import ChipInputSelect from "../../../../framework/ChipInputSelect";
import GlobalContext from "../../../../framework/GlobalContext";
import SelectInput from "../../../../framework/SelectInput";
import NumberInput from "../../../../framework/NumberInput";
import TextInput from "../../../../framework/TextInput";

import { gstTypes } from "../../../../utils/constant";
import {
  checkErrorStateExists,
  formStateHandler,
} from "../../../../utils/utils";
import { displayToast } from "../../../../framework/toast/toastUtils";

const MiscellaneousTab = (props) => {
  const {
    removeErrorStateOnChange = () => {},
    validateForm = () => {},
    editBankId= null,
    branches,
  } = props;
  const { setCurrentComponent } = useContext(GlobalContext);
  const withPincodeCap = ({ value }) => value.length <= 6;
  const dispatch = useDispatch();
  // const [branch , setBranch] = useState([]);
  // const [branches, setBranches] = useState([]);
  const branchRef = useRef("");

  const { formState , errorState } = useSelector(
    (state) => state.commonReducer.common.addBank || {}
  );

  const dispatchFormState = useCallback(
    (newState) => {
      dispatch({
        type: "set_add_bank_form_state", 
        payload: newState,
      });
    },
    [dispatch]
  );
  
  const debounceDispatchFormState = useCallback(
    debounce(dispatchFormState, 1),
    [dispatchFormState]
  );
  
  const handleFormChange = useCallback(
    (fieldName, fieldValue, isSelect = false, options) => {
      let newFormState = formStateHandler(
        formState,
        fieldName,
        fieldValue,
        isSelect,
        options
      );
      debounceDispatchFormState(newFormState);
    },
    [debounceDispatchFormState, formState]
  );
  const validateGstin = useCallback((gstin) => {
    if (!gstin) {
      return true;
    }
    const gstinRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}Z[A-Z\d]{1}$/;
    if (!gstinRegex.test(gstin)) {
      displayToast({
        type: "error",
        title: "Please enter a valid GSTIN.",
      });
      return;
    }
    displayToast({
      type: "success",
      title: "GSTIN is valid.",
    });
    return true;
  }, []);  
  return (
    <>
        <Grid
          container
          spacing={2}
          sx={{ margin: "5px 0px 5px -10px", width: "100%" }}
        >
          <Grid item xs={1.8}>
            <SelectInput
              id="add_bank_gstType"
              name="gstinType"
              value={formState?.gstinType}
              label="GST Type"
              onFocus={() => setCurrentComponent("add_bank_gstType")}
              onBlur={(e) => {
                validateForm("add_bank_gstType", formState);
              }}
              onChange={(event, option) => {
                removeErrorStateOnChange("add_bank_gstType");
                handleFormChange("gstinType", option);
              }}
              options={gstTypes}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => {
                return option.label === value.label;
              }}
              markers={JSON.stringify({
                up: "add_bank_gstType",
                down: "add_bank_pin_code",
                right: "add_bank_permanent_gstin",
              })}
              error={checkErrorStateExists(
                "add_bank_gstType",
                errorState
              )}
              autoFocus
            />
          </Grid>

          <Grid item xs={1.8}>
            <TextInput
              id="add_bank_permanent_gstin"
              name="Permanentgstin"
              label="Permanent GSTIN"
              onChange={(e) => {
                const upperValue = e.target.value.toUpperCase();
                handleFormChange("gstin", upperValue);
              }}
              value={formState?.gstin}
              onFocus={() => {
                setCurrentComponent("add_bank_permanent_gstin");
              }}
              onBlur={() => {
                const gstin = formState?.gstin;
                validateGstin(gstin);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_permanent_gstin",
                  down: "add_bank_city",
                  left: "add_bank_gstType",
                  right: "add_bank_provisional_gstin",
                }),
              }}
            />
          </Grid>

          <Grid item xs={1.8}>
            <TextInput
              id="add_bank_provisional_gstin"
              name="provisionalgstin"
              label="Provisional GSTIN"
              onChange={(e) => {
                const upperProvisionalValue = e.target.value.toUpperCase();
                handleFormChange("provisionalGstin", upperProvisionalValue);
              }}
              value={formState?.provisionalGstin}
              onFocus={() => {
                setCurrentComponent("add_bank_provisional_gstin");
              }}
              onBlur={() => {
                const provisionalGstin = formState?.provisionalGstin;
                validateGstin(provisionalGstin);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_provisional_gstin",
                  down: "add_bank_area",
                  left: "add_bank_permanent_gstin",
                  right: "add_bank_address",
                }),
              }}
            />
          </Grid>

          <Grid item xs={1.8}>
            <TextInput
              id="add_bank_address"
              name="address"
              label="Address"
              onChange={(e) => {
                handleFormChange("bankAddress", e.target.value);
              }}
              value={formState?.bankAddress}
              onFocus={() => {
                setCurrentComponent("add_bank_address");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_address",
                  down: "add_bank_region",
                  left: "add_bank_provisional_gstin",
                  right: "add_bank_locality",
                }),
              }}
            />
          </Grid>

          <Grid item xs={1.8}>
            <TextInput
              id="add_bank_locality"
              name="locality"
              label="Locality"
              onChange={(e) => {
                handleFormChange("locality", e.target.value);
              }}
              value={formState?.locality}
              onFocus={() => {
                setCurrentComponent("add_bank_locality");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_locality",
                  down: "add_bank_country",
                  left: "add_bank_address",
                  right: "add_bank_email",
                }),
              }}
            />
          </Grid>


          <Grid item xs={1.8}>
            <TextInput
              id="add_bank_email"
              name="email"
              label="Email"
              onChange={(e) => {
                handleFormChange("bankEmail", e.target.value);
              }}
              value={formState?.bankEmail}
              onFocus={() => {
                setCurrentComponent("add_bank_email");
              }}
              onBlur={() => {
                if (formState.bankEmail)
                  validateForm("email", formState);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_email",
                  down: "add_bank_zone",
                  left: "add_bank_address",
                  right: "add_bank_pin_code",
                }),
              }}
            />
          </Grid>

          <Grid item xs={1.8}>
            <NumberInput
              id="add_bank_pin_code"
              name="pinCode"
              label="Pin Code"
              value={formState?.pincode || ""}
              onBlur={(e) => {
                const pinCode = formState?.pincode;
                if (!pinCode || pinCode.toString().length !== 6) {
                  displayToast({
                    type: "error",
                    title: "Please enter a valid 6-digit pincode.",
                  });
                } else {
                  validateForm("add_bank_pin_code", formState);
                }
              }}
              onFocus={() => setCurrentComponent("add_bank_pin_code")}
              onValueChange={(values) => {
                removeErrorStateOnChange("add_bank_pin_code");
              }}
              onChange={(e) => {
                handleFormChange("pincode", +e.target.value);
              }}
              decimalScale={0}
              allowNegative={false}
              isAllowed={withPincodeCap}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_gstType",
                  down: "add_bank_branch",
                  left: "add_bank_email",
                  right: "add_bank_city",
                }),
              }}
              error={checkErrorStateExists(
                "add_bank_pin_code",
                errorState
              )}
              
            />
          </Grid>

          <Grid item xs={1.8}>
            <TextInput
              id="add_bank_city"
              name="city"
              label="City"
              onChange={(e) => {
                handleFormChange("city", e.target.value);
              }}
              value={formState?.city}
              onFocus={() => {
                setCurrentComponent("add_bank_city");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_permanent_gstin",
                  down: "add_bank_branch",
                  left: "add_bank_pin_code",
                  right: "add_bank_area",
                }),
              }}
            />
          </Grid>

          <Grid item xs={1.8}>
            <TextInput
              id="add_bank_area"
              name="area"
              label="Area"
              onChange={(e) => {
                handleFormChange("area", e.target.value);
              }}
              value={formState?.area}
              onFocus={() => {
                setCurrentComponent("add_bank_area");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_provisional_gstin",
                  down: "add_bank_branch",
                  left: "add_bank_city",
                  right: "add_bank_region",
                }),
              }}
            />
          </Grid>

          <Grid item xs={1.8}>
            <TextInput
              id="add_bank_region"
              name="region"
              label="Region"
              onChange={(e) => {
                handleFormChange("region", e.target.value);
              }}
              value={formState?.region}
              onFocus={() => {
                setCurrentComponent("add_bank_region");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_address",
                  down: "add_bank_branch",
                  left: "add_bank_area",
                  right: "add_bank_country",
                }),
              }}
            />
          </Grid>

          <Grid item xs={1.8}>
            <TextInput
              id="add_bank_country"
              name="country"
              label="Country"
              onChange={(e) => {
                handleFormChange("country", e.target.value);
              }}
              value={formState?.country}
              onFocus={() => {
                setCurrentComponent("add_bank_country");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_locality",
                  down: "add_bank_branch",
                  left: "add_bank_region",
                  right: "add_bank_zone",
                }),
              }}
            />
          </Grid>

          <Grid item xs={1.8}>
            <TextInput
              id="add_bank_zone"
              name="zone"
              label="Zone"
              onChange={(e) => {
                handleFormChange("zone", e.target.value);
              }}
              value={formState?.zone}
              onFocus={() => {
                setCurrentComponent("add_bank_zone");
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_bank_email",
                  down: "add_bank_branch",
                  left: "add_bank_country",
                  right: "add_bank_branch",
                }),
              }}
            />
          </Grid>

          <Grid item xs={12}>
          <ChipInputSelect
            id="add_bank_branch"
            value={formState?.branchCode || null}
            options={branches}
            groupBy={(option) => option.region}
            name="branch"
            required={true}
            ref={branchRef}
            getOptionLabel={(option) => `${option.name} (${option.code})`}
            onFocus={() => {
              setCurrentComponent("add_bank_branch");
            }}
            onChange={(event, option) => {
              handleFormChange("branchCode", option);
              // setBranch(option)
            }}
            openOnFocus={true}
            label="Branches"
            multiple={true}
            blurOnSelect={false}
            disableCloseOnSelect={true}
            renderGroup={(params) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    padding: "5px",
                    gap: "5px",
                  }}
                  key={params.key}
                >
                  <div
                    style={{
                      height: "30px",
                      width: "100%",
                      background: "#e0e0e0",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                    }}
                  >
                    {params.group}
                  </div>
                  <div>{params.children}</div>
                </div>
              );
            }}
            renderOption={(props, option, { selected }) => {
              return (
                <div
                  {...props}
                  style={{
                    display: "flex",
                    height: "40px",
                    width: "100%",
                    padding: "1px 5px",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItem: "center",
                    }}
                  >
                    <Checkbox checked={selected} />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItem: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        height: "15px",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      {option.name} ({option.code})
                    </div>
                    <div
                      style={{
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {option.address}
                    </div>
                  </div>
                </div>
              );
            }}
            markers={JSON.stringify({
              up: "add_user_pin_code",
              left: "add_bank_zone",
              right: "add_bank_branch",
              down: "add_bank_branch",
            })}
          />
        </Grid>

        </Grid>
    </>
  );
};

export default MiscellaneousTab;
